module.exports = __webpack_public_path__ + "img/logo.effbba99.png";